module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "paypal.4bb79df7.svg";